import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featuredArticles = getFeaturedArticles(6);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
              精选文章
            </h2>
            <p className="text-sm text-foreground-500">
              最新、最有深度的换妻文化分析
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/xinli-dongji"
            className="inline-flex items-center gap-2 px-5 py-2.5 border border-foreground-200 rounded-md text-sm text-foreground-700 hover:text-primary-600 hover:border-primary-300 transition-colors whitespace-nowrap"
          >
            浏览全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}